import React from "react";
import SvgIcon from "@/components/ui/SvgIcon";
import backIcon from "@/assets/img/icons/Back.svg"; 

interface AboutAppModalContentProps {
  onBack: () => void;
  aboutText: string;
}

const AboutAppModalContent: React.FC<AboutAppModalContentProps> = ({ onBack, aboutText }) => (
  <div className="w-full max-w-md p-0 text-white">
    <div className="text-lg font-bold px-3 pt-6 pb-4 flex items-center justify-start">
    <button
      className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/10 transition flex-shrink-0"
      onClick={onBack}
      aria-label="Назад"
      type="button"
    >
        <SvgIcon
          src={backIcon}
          className="w-6 h-6"
          color="#ffffff"
        size={24}
      />
    </button>
         О приложении</div>
    <div className="px-6 pb-4 text-base opacity-90 leading-relaxed max-h-[250px] overflow-y-auto">
    {aboutText}
    </div>
    <div className="px-6 pb-4 text-xs opacity-60">© 2025 Все права защищены BytePace.</div>
  </div>
);

export default AboutAppModalContent; 
